import { useSelector } from 'react-redux';

import { isImpersonatingUser } from 'selectors';

const useIsImpersonatingUser = () => {
  return useSelector(isImpersonatingUser);
};

export { useIsImpersonatingUser };
